import { render } from "./PaymentSucceededModal.vue?vue&type=template&id=983be48e"
import script from "./PaymentSucceededModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PaymentSucceededModal.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script